import React, { useEffect, useState } from 'react';
import { BrowserRouter } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './home';
import ScrollButton from './scrollButton';
import logo from './images/logo1.png';

import View from './view';
import Footer from './components/Footer';
import './App.css';

const App = () => {
  const [img, setImg] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setImg(false);
    }, 2000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
     {img ? (
  <div className="d-flex justify-content-center align-items-center vh-100 bg-light">
    <div className="brick-bg-container position-relative">
      <div className="brick-grid">
        {[...Array(64)].map((_, i) => (
          <div key={i} className="brick" style={{ animationDelay: `${i * 20}ms` }}></div>
        ))}
      </div>

    </div>
  </div>
): (
        <div>
          <BrowserRouter>
            <Navbar />
            <Home />
            <ScrollButton />
            <Footer />
          </BrowserRouter>
        </div>
      )}
    </>
  );
};

export default App;
